import React from 'react';
import noDataImage from '@assets/images/icons/empty-cart.svg';
import { useNavigate } from 'react-router-dom';
import { resetPreSelectedFilters } from '@common/utils/utils';

function Nodata({visible, imgUrl, resetFilters, handleFilterCategory, buttonText, msgText}) {
  const navigate = useNavigate();

  return (
    <div className={`bs-message ${visible ? 'bs-message--visible' : ''}`}>
        <div className='bs-message__image-wrap'>
            <img src={imgUrl ? imgUrl : noDataImage} alt="no data"/>
        </div>
        {msgText ? (
          <div className='bs-message__msg-wrap'>
            <p className='bs-message__msg'>{msgText}</p>
          </div>
        ) : null}
        <div className='bs-message__action-wrap'>
            <button 
              className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-large' 
              onClick={() => {
                if(window.location.pathname.includes('/products')) {
                  resetPreSelectedFilters();
                  if(resetFilters)
                    resetFilters();
                  if(handleFilterCategory)
                    handleFilterCategory('');
                } else {
                  resetPreSelectedFilters();
                }
                navigate('/products')
              }}
            >{buttonText && buttonText !== '' ? buttonText : 'go to shopping'}</button>
        </div>
    </div>
  )
}

export default Nodata